import React from "react";
import bannerImage from "@assets/digital-illustration-section_1_1.svg";

interface HeroSectionProps {
  onBookDemo: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onBookDemo }) => {
  return (
    <section className="2xl:h-[calc(100vh-96px)] h-[calc(100vh-75px)]  w-full flex flex-col md:flex-row items-center justify-between px-5 md:px-24 bg-[#EDF2FC] pt-4 pb-[12rem] md:pt-0 md:pb-[8rem] snap-start transition-all duration-700">
      <div className="max-w-xl flex flex-col items-center md:block">
        {/* mobile */}
        <h1 className="text-2xl text-center font-semibold text-gray-800 mb-4 md:hidden">
          The Intuitive Workspace
          <br />
          for Philanthropic
          <br />
          Organisations
        </h1>
        {/* desktop */}
        <h1 className="text-3xl 2xl:text-4xl font-bold text-gray-800 mb-4 hidden md:block">
          The Intuitive Workspace for Philanthropic Organisations
        </h1>

        {/* mobile */}
        <p className="text-gray-600 mb-6 text-sm md:hidden text-center max-w-md">
          THE ARK empowers NGOs and foundations with smarter tools for program
          management, reporting and seamless collaboration—so you can focus on
          impact, not admin
        </p>
        {/* desktop */}
        <p className="text-gray-600 mb-6 text-base 2xl:text-lg hidden md:block">
          THE ARK empowers NGOs and foundations with
          <br /> smarter tools for program management, reporting
          <br />
          and seamless collaboration—so you can focus on
          <br />
          impact, not admin
        </p>

        <button
          onClick={onBookDemo}
          className="bg-blue-600  text-white text-base 2xl:text-lg text-sm font-semibold md:px-6 px-3 md:py-2 py-2 rounded hover:bg-blue-700 transition "
        >
          Book a Demo
        </button>
      </div>
      <img src={bannerImage} alt="Section One" className="w-[90%] md:w-[40%]" />
    </section>
  );
};

export default HeroSection;
